import { Box, Typography } from '@mui/material';
import styles from './map.module.scss';

type Loc = { title: string; src: string };

const locations: Loc[] = [
    {
        title: 'Mińsk Mazowiecki',
        src: 'https://maps.google.com/maps?q=UFO%20Salon%20meblowy%20Mi%C5%84sk%20Mazowiecki&hl=pl&z=12&output=embed',
    },
    {
        title: 'Warszawa',
        src: 'https://maps.google.com/maps?q=UFO%20MEBLE%20GROCHOWSKA%20WARSZAWA&hl=pl&z=12&output=embed',
    },
    {
        title: 'Piaseczno',
        src: 'https://maps.google.com/maps?q=SALON%20MEBLOWY%20UFO%20MEBLE%20Piaseczno&hl=pl&z=12&output=embed',
    },
];

const accents = ['#2f3ea4', '#dc2430', '#414345'] as const;

const hexToRgba = (hex: string, a: number) => {
    const h = hex.replace('#', '');
    const bigint = parseInt(h.length === 3 ? h.split('').map(c => c + c).join('') : h, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
};

export default function Map() {
    return (
        <div className={styles.general}>
            <Typography
                component="h1"
                sx={{
                    fontWeight: 900,
                    textAlign: 'center',
                    mb: { xs: 2.5, sm: 3.5 },
                    fontSize: { xs: 24, sm: 30 },
                    lineHeight: 1.15,
                    backgroundImage:
                        'linear-gradient(90deg, #2f3ea4 0%, #293a98 40%, #26358f 70%, #223083 100%)',
                    WebkitBackgroundClip: 'text',
                    backgroundClip: 'text',
                    color: 'transparent',
                    letterSpacing: '.01em',
                }}
            >
                Odwiedź jeden z naszych salonów!
            </Typography>

            <Box
                display="flex"
                justifyContent={{ xs: 'center', md: 'space-around' }}
                flexWrap="wrap"
                gap={{ xs: 2.5, md: 3 }}
                sx={{ width: '100%', boxSizing: 'border-box', px: { xs: 0, md: 1 } }}
            >
                {locations.map((l, idx) => {
                    const accent = accents[idx % accents.length];
                    return (
                        <Box
                            key={l.title}
                            sx={{
                                width: { xs: 'min(92vw, 360px)', sm: 400 },
                                flex: '0 0 auto',
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    textAlign: 'center',
                                    fontWeight: 800,
                                    mb: 1,
                                    fontSize: { xs: 20, sm: 22 },
                                    lineHeight: 1.15,
                                    color: '#111827',
                                    position: 'relative',
                                    '&::after': {
                                        content: '""',
                                        display: 'block',
                                        width: 36,
                                        height: 3,
                                        margin: '6px auto 0',
                                        borderRadius: 2,
                                        background: `linear-gradient(90deg, ${accent} 0%, ${accent} 100%)`,
                                        opacity: 0.9,
                                    },
                                }}
                            >
                                {l.title}
                            </Typography>

                            <Box
                                sx={{
                                    p: 0.8,
                                    borderRadius: 2.5,
                                    background: `linear-gradient(120deg, ${hexToRgba(accent, 0.28)}, ${hexToRgba(
                                        accent,
                                        0.18
                                    )})`,
                                }}
                            >
                                <Box
                                    sx={{
                                        position: 'relative',
                                        width: '100%',
                                        aspectRatio: { xs: '16 / 10', sm: '3 / 4' },
                                        borderRadius: 2,
                                        overflow: 'hidden',
                                        boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
                                        backgroundColor: '#fff',
                                        transition: 'transform .15s ease, box-shadow .2s ease',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 12px 28px rgba(0,0,0,0.12)',
                                        },
                                    }}
                                >
                                    <iframe
                                        title={`${l.title.toLowerCase()} map`}
                                        src={l.src}
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        style={{
                                            position: 'absolute',
                                            inset: 0,
                                            width: '100%',
                                            height: '100%',
                                            border: 0,
                                            display: 'block',
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    );
                })}
            </Box>
        </div>
    );
}